import { render, staticRenderFns } from "./ExclusionsCreate.vue?vue&type=template&id=33a8f3ec"
import script from "./ExclusionsCreate.vue?vue&type=script&lang=js"
export * from "./ExclusionsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports